import {
  GET_DEPARTMENTS_REQUEST,
  GET_DEPARTMENTS_SUCCESS,
  GET_DEPARTMENTS_ERROR,
  GET_AUDIT_DEPARTMENTS_REQUEST,
  GET_AUDIT_DEPARTMENTS_SUCCESS,
  GET_AUDIT_DEPARTMENTS_ERROR,
  CREATE_DEPARTMENT_REQUEST,
  CREATE_DEPARTMENT_SUCCESS,
  CREATE_DEPARTMENT_ERROR,
  UPDATE_DEPARTMENT_REQUEST,
  UPDATE_DEPARTMENT_SUCCESS,
  UPDATE_DEPARTMENT_ERROR,
  RESET_DEPARTMENT_STATE,
} from './departmentActionTypes';

const initialState = {
  isLoading: false,
  isSuccess: false,
  departments: [],
  auditDepartments: [],
  pagination: {},
  message: '',
};

export default function departmentReducer(state = initialState, action) {
  const { type, payload, isLoading, isSuccess, message } = action;

  switch (type) {
    case GET_DEPARTMENTS_REQUEST:
      return { ...state, isLoading };
    case GET_DEPARTMENTS_SUCCESS:
      return { ...state, isLoading, departments: payload.data, pagination: payload };
    case GET_DEPARTMENTS_ERROR:
      return { ...state, isLoading, message };

    case GET_AUDIT_DEPARTMENTS_REQUEST:
      return { ...state, isLoading };
    case GET_AUDIT_DEPARTMENTS_SUCCESS:
      return { ...state, isLoading, auditDepartments: payload.data };
    case GET_AUDIT_DEPARTMENTS_ERROR:
      return { ...state, isLoading };

    case CREATE_DEPARTMENT_REQUEST:
    case UPDATE_DEPARTMENT_REQUEST:
      return { ...state, isLoading, isSuccess: false };

    case CREATE_DEPARTMENT_SUCCESS:
    case UPDATE_DEPARTMENT_SUCCESS:
      return { ...state, isLoading, isSuccess };

    case CREATE_DEPARTMENT_ERROR:
    case UPDATE_DEPARTMENT_ERROR:
      return { ...state, isLoading, isSuccess: false, message };

    case RESET_DEPARTMENT_STATE:
      return { ...state, isSuccess: false, message: '' };

    default:
      return state;
  }
}
